import { css } from '../../../common.styles';
import { accentFont, baseColor, mobile, primaryColor } from '../../../styles/general/theme';

export const OpelRichTextStyle = css<{
  paddingLeft?: number;
  paddingRight?: number;
  width?: string;
  standardPro?: boolean;
  disableOverflow?: boolean;
  overFlowWrap?: string;
  removeTopMargin?: boolean;
}>`
  overflow: hidden;
  box-sizing: border-box;
  ${(p) =>
    p.paddingLeft &&
    css`
      padding: ${p.paddingLeft}px 0;
      padding-left: ${p.paddingLeft}px;
    `};
  ${(p) =>
    p.paddingRight &&
    css`
      padding-right: ${p.paddingRight}px;
    `};
  ${(p) =>
    p.width &&
    css`
      width: ${p.width};
    `};

  ${(p) =>
    p.standardPro &&
    css`
      p {
        margin: 0;
      }
    `};

  ${(p) =>
    p.disableOverflow &&
    css`
      overflow: hidden;
    `};
  @media (max-width: ${mobile}px) {
    p {
      img {
        margin: 20px 0 !important;
        object-fit: cover;
        max-width: 100%;
      }
    }
  }

  ${(p) =>
    p.removeTopMargin &&
    css`
      h1,
      h2,
      h3,
      h4,
      h5,
      h6 {
        margin-top: 0 !important;
      }
    `};

  em {
    font-style: italic;

    strong {
      font-style: italic;
    }
  }

  img {
    max-width: 100%;
  }

  a {
    color: ${baseColor(50)};
  }

  b,
  strong {
    font-weight: bold !important;
    font-family: ${accentFont} !important;
  }

  sub {
    vertical-align: sub !important;
    font-size: smaller !important;
  }

  sup {
    vertical-align: super !important;
    font-size: smaller !important;
  }

  p,
  ul {
    font-size: 16px !important;
    font-weight: 300;
  }

  a.primary-button,
  a.secondary-button,
  a.cta-button {
    display: inline-block !important;
    margin-bottom: 10px !important;
    padding: 8px 24px;
    width: auto !important;

    @media (max-width: ${mobile}px) {
      width: auto;
      max-height: fit-content;
    }
  }

  table {
    border-spacing: 0;
    border-collapse: collapse;
    border: 1px solid ${baseColor(50)};

    td,
    th {
      padding: 10px;
      border: 1px solid ${baseColor(50)};
    }

    th,
    thead tr td {
      font-weight: bold !important;
      font-family: ${accentFont} !important;
    }
  }

  .richtext-tooltip {
    & svg {
      pointer-events: none;
      circle {
        stroke-width: 0.7;
        pointer-events: none;
        stroke: ${primaryColor(350)};
      }

      path {
        fill: ${primaryColor(350)};
        stroke-width: 0.5;
        stroke: ${primaryColor(350)};
        pointer-events: none;
      }
    }
  }
`;
